/* eslint-disable max-len */
import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      width: '100%',
      height: '44px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      backgroundColor: '#0C0C0C',
    },
    headerText: {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#ffffff',
      padding: '1px 16px',
    },
    formWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      '& .mantine-Select-input, .mantine-DatePicker-input, .mantine-TextInput-input, .mantine-NumberInput-input , .mantine-DateInput-input , .mantine-Input-input  ': {
        borderRadius: '4px',
        height: '44px',
        border: `1px solid ${colors.disabled.muted}`,
        backgroundColor: colors.bg.default,
        ...getTypographyStyles('content_sm_regular'),
        '&[data-with-icon]': {
          paddingLeft: '48px',
        },
      },
      '.mantine-Button-root': {
        height: '45px',
        border: 'none',
        borderRadius: '8px',
        width: '100%',
        padding: '12px 24px',
        color: '#ffffff',
        fontSize: '16px',
        fontWeight: 500,
      },
      '& .mantine-Select-item': {
        border: 'none',
        width: '100%',
        padding: '12px 24px',
        ...getTypographyStyles('content_sm_regular'),
      },
      '& .mantine-NumberInput-control': {
        borderColor: colors.disabled.muted,
      },
    },
    contentContainer: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflowY: 'auto',
      paddingTop: '0',
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '20px',
    },
    formHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    heading: {
      marginBottom: '9px',
    },
    description: {
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '23px',
      color: '#BFBFBF',
    },
    inputWrapper: {
      width: '100%',
      fontWeight: 500,
      fontSize: '20px',
    },
    input: {
      height: '45px',
      background: '#FFFFFF1A',
      border: 'none',
      outlineColor: '#019DE6',
      outlineWidth: '1px',
      borderRadius: '8px',
      width: '100%',
      padding: '12px 24px',
      color: '#ffffff',
      fontSize: '16px',
      fontWeight: 500,
      letterSpacing: '130%',
      '&::placeholder': {
        color: '#959EB2',
      },
    },
    inputDescription: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#8C8C8C',
      marginTop: '8px',
    },
    inputError: {
      color: 'red',
    },
    popularBankList: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between',
    },
    footerContainer: {
      background: colors.base.white,
    },
    footerButtonWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
    },
    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px',
      gap: '10px',
      background: '#262626',
      borderRadius: '6px',
      border: 'none',
      color: '#ffffff',
      fontSize: '14px',
      marginBottom: '10px',
      ':hover': {
        cursor: 'pointer',
      },
    },
    newButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px',
      gap: '10px',
      width: '118px',
      background: '#EB2F96',
      borderRadius: '5px',
      border: 'none',
      color: '#ffffff',
    },
    // selectWrapper: {
    //   '& .mantine-Select-input, .mantine-DatePicker-input, .mantine-TextInput-input, .mantine-NumberInput-input': {
    //     height: '45px',
    //     backgroundColor: theme.other.colors.backgroundInputs,
    //     border: 'none',
    //     outlineColor: '#019DE6',
    //     outlineWidth: '1px',
    //     borderRadius: '8px',
    //     width: '100%',
    //     padding: '12px 24px',
    //     color: '#ffffff',
    //     fontSize: '16px',
    //     fontWeight: 500,
    //   },
    //   '& .mantine-Select-item': {
    //     border: 'none',
    //     width: '100%',
    //     padding: '12px 24px',
    //     color: '#ffffff',
    //     fontSize: '16px',
    //     fontWeight: 500,
    //   }
    // },
    changeNumberLink: {
      color: '#1DBBF0',
      fontSize: '16px',
      fontWeight: 500,
      border: 'none',
      backgroundColor: 'transparent',
      outline: 'none',
      textAlign: 'left',
      paddingLeft: '4px',
      marginTop: "1.5rem",
      '&:disabled': {
        color: '#8c8c8c',
      },
      marginBottom: "4rem",
    },
    skipBtn: {
      margin: '0px',
    },
    removeBtn: {
      margin: '0px',
    },
    nomineeHeader: {
      height: 97,
      zIndex: 999999,
    },
    skipNomineeCta: {
      ':hover': {
        color: colors.primary.default,
      },
      ...getTypographyStyles('content_sm_regular'),
    },
    skipBtnLabel: {
      ...getTypographyStyles('content_sm_medium'),
    },
  };
});

export default {};
